import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class DatetimeComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentDatetime | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.allowInfinity = settings?.allowInfinity ?? false;
		this.autofocus = settings?.autofocus ?? false;
		this.datePicker = {
			initDate:    '',
			maxDate:     null,
			maxMode:     'year',
			minDate:     null,
			minMode:     'day',
			showWeeks:   true,
			yearColumns: 5,
			yearRows:    4,
			...settings?.datePicker
		};
		this.datepickerMode = settings?.datepickerMode ?? 'day';
		this.defaultDate = settings?.defaultDate ?? '';
		this.disabled = settings?.disabled ?? false;
		this.enableDate = settings?.enableDate ?? true;
		this.enableTime = settings?.enableTime ?? true;
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.format = settings?.format ?? 'yyyy-MM-dd HH:mm a';
		this.input = true;
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.persistent = settings?.persistent ?? true;
		this.placeholder = settings?.placeholder ?? '';
		this.protected = settings?.protected ?? false;
		this.timePicker = {
			arrowkeys:     true,
			hourStep:      1,
			minuteStep:    1,
			mousewheel:    true,
			readonlyInput: false,
			showMeridian:  false,
			...settings?.timePicker
		};
		this.validate = {
			card: new Card(settings?.validate?.card ?? '0-1'),
			custom: settings?.validate?.custom,
			customMessage: settings?.validate?.customMessage,
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'name',
		]);
	}
}